
import {
    AUTH_ERROR,
    AUTH_SUCCESS,
    ERROR_MESSAGE,
    LOADED,
    LOADING,
    SUCCESS_MESSAGE,
    VALIDATION_AUTH_ERROR,
    VALIDATION_ERROR,
} from './types';

import history from '../history';
import api from './apis';
import axios from 'axios';


// ========================Get Profile==========================
export const getProfileDetails = () => async (dispatch) => {
  
    dispatch({type: LOADING});
    try {
      const response = await api(localStorage.getItem("token")).get(`/profile-detail`
      );
      if(response.status === 200){

        dispatch({type: LOADED});
        return response.data
      }
      
      
    } catch (err) {
      /* =============Start========== */
      console.log(err?.response?.status)
        
        if(err?.response?.status === 451 ){
          history.push('/pending-verification')
        }
        
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        
        if(err.message == 'Network Error')
        {
            history.push('/maintenance')
            return
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
        dispatch({type: LOADED});
      /* ===========End============*/}
  };
  
// ========================Update profile=========================
export const updateProfile = (data) => async (dispatch) => {
  
      dispatch({type: LOADING});
      const object = {
        mobile_number: data.mobile_number,
        email : data.email
      };
      
      try {
        const response = await api(localStorage.getItem("token")).patch(
          "update-profile",
          { ...object }
        );
    
        if (response.status === 201) {
          
        dispatch({type: LOADED});
        dispatch({ type: SUCCESS_MESSAGE, payload: response.data.message });
        return response.status
        
        }
      } catch (err) {
        /* =============Start========== */
          if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }

          
        if(err?.response?.status === 451)
        {
          history.push('/pending-verification')
        }
          
        if(err.message == 'Network Error')
        {
            history.push('/maintenance')
            return
        }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
          dispatch({type: LOADED});
      }
    };
  
// ========================Update address=========================
export const updateAddress = (data) => async (dispatch) => {
  
      dispatch({type: LOADING});
      const object = {
        street_address: data.street_address,
        post_code : data.post_code,
        city : data.city,
      };
      
      try {
        const response = await api(localStorage.getItem("token")).patch(
          "update-address",
          { ...object }
        );
    
        if (response.status === 201) {
          
        dispatch({type: LOADED});
        dispatch({ type: SUCCESS_MESSAGE, payload: response.data.message });
        try{
            const res = await api(localStorage.getItem("token")).get(`/profile-detail`);
            if(res.status === 200){
              localStorage.setItem("brand", res.data.data.brand_name);
              localStorage.setItem("dp", res.data.data.client_image);
              localStorage.setItem("city", res.data.data.address?.city);
              localStorage.setItem("post_code", res.data.data?.address?.post_code);
              localStorage.setItem("street_address", res.data.data?.address?.street_address);
            } 
            return response.status

        }catch(err){

          if(err?.response?.status === 451 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/pending-verification')
          }
        }
        
        }
      } catch (err) {
        /* =============Start========== */
          if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          
      if(err?.response?.status === 451)
      {
        history.push('/pending-verification')
      }
          
        if(err.message == 'Network Error')
        {
            history.push('/maintenance')
            return
        }

          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
          dispatch({type: LOADED});
      }
    };
  
// ========================Update password=========================
export const updatePassword = (data) => async (dispatch) => {
  
      dispatch({type: LOADING});
      const object = {
        new_password: data.new_password,
        old_password : data.old_password,
      };
      
      try {
        const response = await api(localStorage.getItem("token")).patch(
          "update-password",
          { ...object }
        );
    
        if (response.status === 201) {
          
        dispatch({type: LOADED});
        dispatch({ type: SUCCESS_MESSAGE, payload: response.data.message });
        localStorage.setItem('token',response.data.token)
        return response.status
        
        }
      } catch (err) {
        /* =============Start========== */
          if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          
          if(err?.response?.status === 451 ){
            history.push('/pending-verification')
          }

          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }

          
        if(err.message == 'Network Error')
        {
            history.push('/maintenance')
            return
        }

          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
          dispatch({type: LOADED});
      }
    };
    
// // ========================Remove Product Image=========================
// export const updateProductImage = (data,product) => async (dispatch) => {
  
//   // console.log(data)
//     dispatch({type: LOADING});
//     const object = {
//       file : data.thumbnail.fileList[0].response.name,
//       product : product,
//       type : 'product-thumbnail'
//     };
   
    
//     try {
//       const response = await api(localStorage.getItem("token")).patch(
//         "file/user/update",
//         { ...object }
//       );
  
//       if (response.status === 201) {
        
//       dispatch({type: LOADED});
//       console.log(response)
//       dispatch({ type: SUCCESS_MESSAGE, payload: response.data.message });
//       return response.status
//       }
//     } catch (err) {
//       /* =============Start========== */
//         if(err?.response?.status === 422){
//           err.response.data.errors.map(item => {
//               dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
//           })
//         }
//         if(err?.response?.status === 401 || err?.response?.status === 403 ){
//             dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
//             localStorage.clear();
//             history.push('/login')
//         }
//         dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
//         dispatch({type: LOADED});
//     }
//   };
  
// ========================Update Product Image=========================
export const updateBrandImage = (data) => async (dispatch) => {
  

    const object = {
      file : data.brand_image.fileList[0].response.name,
      type : 'dp'
    };
   
    
    try {
      const response = await axios (`${process.env.REACT_APP_API_BASE_URL}/client/file/user/delete`,
      {
          headers: {
              'content-type': 'application/json',
              'authorization': `Bearer ${localStorage.getItem("token")}`
          },
          data: {
            file : 'null',
            type : 'dp'
          },
          method: 'delete'
      
      })
      if(response.status === 201){
        const res = await api(localStorage.getItem("token")).patch(
              "file/user/update",
              { ...object }
            );
  
      if (res.status === 201) {
        dispatch({type: LOADED});
     
        dispatch({ type: SUCCESS_MESSAGE, payload: res.data.message });
        const response = await api(localStorage.getItem("token")).get(`/profile-detail`);
                  if(response.status === 200){
                    localStorage.setItem("brand", response.data.data.brand_name);
                    localStorage.setItem("dp", response.data.data.client_image);
                  } 
        return res.status
      }
    }
    } catch (err) {
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        
        if(err?.response?.status === 451 ){
          history.push('/pending-verification')
        }
        
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        
        if(err.message == 'Network Error')
        {
            history.push('/maintenance')
            return
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
        dispatch({type: LOADED});
    }
  };